import { defineStore } from "pinia";
import { store } from "/@/store";
import { usePermissionStore } from "/@/store/modules/permission";
import { Register, RegisterStatus } from "@/models/register";
import axios from "@/http/axios";
import { PageListResult } from "@/models/page";
import { useUserStore } from "./user";

export const useRegisterStore = defineStore({
  id: "register",
  state: () => ({
    registers: [] as Register[],
    currentRegister: null as Register | null,
  }),
  getters: {},
  actions: {
    async loadRegisters() {
      const res = await axios.get<PageListResult<Register>>({
        url: "register",
        query: {
          isPersonal: true,
          status: RegisterStatus.Success,
          all: true,
        },
      });
      if (!res) return;

      this.registers = res.list;

      const userStore = useUserStore();
      const registerToken = `CURRENT_REGISTER_TOKEN_${userStore.getUserInfo?.id}`;
      const cacheRegisterId = localStorage.getItem(registerToken);
      const register =
        this.registers.filter(
          (r) =>
            !!cacheRegisterId && r.organizationId == Number(cacheRegisterId),
        )[0] ||
        this.registers[0] ||
        null;

      this.currentRegister = register;
    },
    async selectRegister(register: Register | null) {
      const beforeRegister = this.currentRegister;
      const userStore = useUserStore();
      const registerToken = `CURRENT_REGISTER_TOKEN_${userStore.getUserInfo?.id}`;
      localStorage.setItem(
        registerToken,
        register?.organizationId?.toString() ?? "",
      );

      this.currentRegister = register;
      if (
        (register != null && beforeRegister == null) ||
        (register == null && beforeRegister != null) ||
        (register != null &&
          beforeRegister != null &&
          (!!register.unitRealname != !!beforeRegister.unitRealname ||
            !!register.playerRealname != !!beforeRegister.playerRealname))
      ) {
        const permissionStore = usePermissionStore();
        await permissionStore.rebuildRoutesAction();
      }
    },
    resetState() {
      this.currentRegister = null;
      this.registers = [];
    },
  },
});

export function useRegisterStoreWithOut() {
  return useRegisterStore(store);
}
